import { type PropsWithChildren } from '@shared/utils';
import { createContext, useCallback, useMemo, useState } from 'react';

import { EditQSetIdNumberModal } from '../../containers';

import type {
  ManuallyEditQSetModalContextValue,
  ManuallyEditQSetModalSetActionType,
} from './types';

export const ManuallyEditQSetModalContext = createContext<
  ManuallyEditQSetModalContextValue | undefined
>(undefined);

export default function ManuallyEditQSetModalProvider(props: Readonly<PropsWithChildren>) {
  const { children } = props;
  const [action, setAction] = useState<ManuallyEditQSetModalSetActionType>({ type: null });

  const handleSetAction = useCallback(
    (action: ManuallyEditQSetModalSetActionType) => {
      setAction(action);
    },
    [setAction],
  );

  const handleClose = useCallback(() => {
    setAction({ type: null });
  }, []);

  const contextValue: ManuallyEditQSetModalContextValue = useMemo(() => {
    return {
      close: handleClose,
      setAction: handleSetAction,
    };
  }, [handleClose, handleSetAction]);

  return (
    <ManuallyEditQSetModalContext.Provider value={contextValue}>
      {children}
      <EditQSetIdNumberModal
        open={action.type === 'manually-edit-qset'}
        onClose={handleClose}
        examEventId={action.type === 'manually-edit-qset' ? action.examEventId : ''}
      />
    </ManuallyEditQSetModalContext.Provider>
  );
}
